export const Sizes = {
  battleCard: {
    ratio: 120 / 80,
    width: 150,
    radius: 4,
  },
  card: {
    ratio: 377 / 274,
    width: 274,
    radius: 12,
  },
  intrigueCard: {
    width: 150,
    ratio: 120 / 80,
  },
  cardWidths: {
    normal: 156,
    small: 75,
  },
};
